import React, { useEffect, useState } from 'react';
import { CurrencyField, DataTable } from '../../../commons/DataTable';
import GiveAndTakeLinkField from '../../../commons/DataTable/GiveAndTakeLinkField';
import { useTranslation } from 'react-i18next';
import { ContAffiliation, H5Styled } from '../../../styled-components';
import { Col, Row } from 'reactstrap';
import { formatCurrency } from '../../../lib/helpers/formatters';

function GiveTable({ data, total, offset, limit, onFilter }) {
  const [t] = useTranslation('GIVE_AND_TAKE');
  const [giveData, setGiveData] = useState([]);
  const [allTotalsSum, setAllTotalsSum] = useState(0);

  useEffect(() => {
    let foundedData = data.filter((item) => item.type === 'GIVE');
    if (foundedData) {
      foundedData = foundedData.map((item) => {
        if (item.totals) {
          item.totals.total = item.totals.total - item.totals.insurances;
        }
        return item;
      });
    }
    setGiveData(foundedData);
    setAllTotalsSum(
      formatCurrency(
        foundedData
          .reduce((sum, item) => sum + (item.allTotals?.total || 0), 0)
          .toFixed(2)
      )
    );
  }, [data]);

  return (
    <>
      <ContAffiliation>
        <Row>
          <Col xs="6">
            <H5Styled>
              {t('GIVE')} - totale competenze passive: {allTotalsSum}
            </H5Styled>
          </Col>
          <Col xs="6" className="text-right" />
        </Row>
        <br />
        <br />
        <DataTable
          data={giveData}
          total={total}
          offset={offset}
          limit={limit}
          onFilter={onFilter}
          emptyText={t('COMMON:NO_DATA')}
        >
          <CurrencyField
            title="Totale fatture"
            source="totals.invoices"
            tooltip={t('TOTAL_INVOICES_GIVE_TOOLTIP')}
            className="txt-table-right"
          />
          <CurrencyField
            title="Totale fee energia"
            source="totals.fees"
            tooltip={t('TOTAL_FEES_GIVE_TOOLTIP')}
            className="txt-table-right"
          />
          <CurrencyField
            title="Totale fee ricorrenti energia"
            source="totals.recurringFees"
            tooltip={t('TOTAL_RECURRING_FEES_GIVE_TOOLTIP')}
            className="txt-table-right"
          />
          <CurrencyField
            title="Totale"
            source="totals.total"
            className="txt-table-right"
          />
          <GiveAndTakeLinkField
            title="Dettagli"
            source="cumulativeFileUrl"
            className="text-left"
          />
        </DataTable>
      </ContAffiliation>
    </>
  );
}

export default GiveTable;
